module.exports = __webpack_public_path__ + "media/images/facebook-8036dcc98e3b94b329b22acb3bad8343.png";